export default function Logo({ dark = false }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <svg width="34" height="34" viewBox="0 0 40 40" aria-hidden="true">
        <rect x="4" y="13" width="5" height="14" rx="1.2" fill="#C9A227" />
        <path
          d="M 18.75 10.9 A 10.5 10.5 0 1 1 18.75 29.1"
          stroke={dark ? "#FFFFFF" : "#0B1F3A"}
          strokeWidth="6.5"
          fill="none"
          strokeLinecap="round"
        />
      </svg>
      <span className="leading-none">
        <span className={`block font-display text-[17px] font-extrabold tracking-tight ${dark ? "text-white" : "text-[#0B1F3A]"}`}>
          Incremental
        </span>
        <span className={`block text-[10px] font-semibold uppercase tracking-[0.32em] ${dark ? "text-[#C9A227]" : "text-[#A87B1F]"}`}>
          Consulting
        </span>
      </span>
    </span>
  );
}
